/**
 * created by evan on 2019-10-11
 */
/* eslint-disable */

import store from '../store/index'
import apiConfig from '@/api/apis.js';
import weui from 'weui.js'
import axios from 'axios' //文档地址 http://www.axios-js.com/

/**
 * @param status
 */
axios.defaults.validateStatus = function (status) {
  return status < 500 // Reject only when the status code is greater >= 500
}

/**
 *  handle request
 * @param requestApi 请求接口
 * @param data 请求参数
 * @param apis 接口集
 * @param ext 超时时间
 */
const Api = async (requestApi, data = {}, apis = apiConfig, ext = {timeout: 10000}) => {

  let api = apis[requestApi];

  let {url, method, params} = api

  const config = {}

  const token = store.state.common.token || localStorage.getItem('token')

  if (token) {
    config.headers = {
      Authorization: token
    }
  }

  data = {...params, ...data};
  config.url = /^http/.test(url) ? url : process.env.VUE_APP_API_URL + url;
  config.method = method


  if (['put', 'post', 'patch'].includes(method)) {
    config.data = data
  }

  if (method === 'get') {
    config.params = Object.assign({}, data)
  }
  try {
    const {data: resData} = await axios(config)
    const {code, status_code: statusCode , data} = resData
    console.log('window.$vueObj', window.$vueObj)
    if (code === 0 || statusCode === 200) {
      return data
    } else {
      // 处理错误
      if(resData.message && resData.message !== '认证失败, 请重新登录') { // token过期不给提示
        weui.toast(resData.message, { className: 'my-weui' })
      }
      if (statusCode === 401) { // 401：token失效时，清除token，跳转到登陆页
        window.localStorage.setItem('token', '')
        window.localStorage.setItem('loggedUser', '')
        if (window.location.href.indexOf('activityDetail')>=0) {
          return {public: true}
        } else {
          window.$vueObj.$router.replace({
            name: 'login',
            query: {
              id: window.$vueObj.$route.query.id
            }
          })
        }
      }
      return Promise.reject(resData)
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

export default Api
